import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {Tooltip} from "../../../../core/components/tooltip/tooltip";
import {StandingsWidgetLegendContent} from "./standings-widget.legend-content";
import {TOOLTIP_TRIGGER} from "../../../../core/components/tooltip/tooltip-consts";
import {StandingsWidgetController} from "../../standings-widget.controller";
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";

class StandingsLegendButtonProps extends BaseProps {
  controller: StandingsWidgetController;
}

export const StandingsLegendButton = ({controller}: StandingsLegendButtonProps) => {
  const {terms, state} = controller;

  const tooltipContentProps = {
    controller,
    className: classNames(styles.legend_button_content),
  }

  const tooltipProps = {
    className: classNames(styles.legend_button),
    content: <StandingsWidgetLegendContent {...tooltipContentProps}/>,
    trigger: TOOLTIP_TRIGGER.click,
    interactive: true,
    ignoreDeviceWidth: true,
  }

  return (
    state.shouldRenderLegendButton ? <div className={classNames(styles.legend_button_container)}>
      <Tooltip {...tooltipProps}>
        <div className={classNames(styles.legend_button_text)}>{terms.STANDINGS_LEGEND}</div>
        <div className={classNames(styles.legend_button_icon)}>?</div>
      </Tooltip>
    </div> : null
  )
}
